/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import {
  FETCHED_DELEGATION_LOG,
  FETCHING_DELEGATION_LOG,
  FETCH_DELEGATION_LOG_ERROR,
  ERROR_DELEGATIONLOG_EXPORT_CSV,
  FETCHING_DELEGATIONLOG_EXPORT_CSV,
  RECEIVE_DELEGATIONLOG_EXPORT_CSV
} from '../actions/actionTypes';

const initialDelegationLogState = {
  assignments: null,
  error: null,
  errorExport: null,
  isFetching: false,
  isFetchingExport: false,
  objectBlob: null
};

const delegationLogReducer = (state = initialDelegationLogState, action) => {
  switch (action.type) {
    case FETCHING_DELEGATION_LOG:
      return Object.assign({}, state, initialDelegationLogState, { isFetching: true });
    case FETCHED_DELEGATION_LOG:
      return Object.assign({}, state, initialDelegationLogState, action.payload);
    case FETCH_DELEGATION_LOG_ERROR:
      return Object.assign({}, state, initialDelegationLogState, { error: action.payload });
    case ERROR_DELEGATIONLOG_EXPORT_CSV:
      return Object.assign({}, state, { isFetchingExport: false, objectBlob: null, errorExport: action.payload });
    case FETCHING_DELEGATIONLOG_EXPORT_CSV:
      return Object.assign({}, state, { isFetchingExport: true, errorExport: null });
    case RECEIVE_DELEGATIONLOG_EXPORT_CSV:
      return Object.assign({}, state, {
        isFetchingExport: false,
        errorExport: null,
        objectBlob: action.payload.objectBlob
      });

    default:
      return state;
  }
};

export default delegationLogReducer;
